<template>
  <div class="container py-5">

    <p>
    TSK即將參與“ISDS 國際皮膚外科學會”！ 
    <br>我們的醫學美容尖針與鈍針，結合多項創新技術，為醫療專業人士提供安全、優質且令人安心的產品。期待在展會與您分享TSK的卓越技術與服務。<br><br> 展會時間：2024年9月13日(五) - 15日(日) <br> 展會地點：高雄展覽館<br> 攤位編號：F06
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_45.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
